/**
 * ⚠ MARKED FOR RETIREMENT (2026-08-09) — DO NOT USE IN NEW CODE.
 *
 * A fourth, obsolete item-status enum with a WHOLLY DIFFERENT numbering scheme
 * from the live `ItemStatus` (src/enums/commerce/ItemStatus.js), which is the one
 * the backend actually sends. Compare:
 *
 *   PENDING          1  ==  ItemStatus.PENDING           1   ✓
 *   COLLECTING       2  vs  ItemStatus.COLLECTING       11   ✗
 *   COLLECTED        3  vs  ItemStatus.COLLECTED        21   ✗
 *   PACKAGED         4  vs  ItemStatus.PACKAGED         22   ✗
 *   SHIPPED          5  ==  ItemStatus.SHIPPED           5   ✓ (coincidence)
 *   DELIVERED        6  vs  ItemStatus.DELIVERED        24   ✗
 *   CANCELLED        7  ==  ItemStatus.CANCELLED         7   ✓
 *   OUT_OF_STOCK     8  vs  ItemStatus.OUT_OF_STOCK     41   ✗
 *   ISSUE            9  vs  ItemStatus.ISSUE            31   ✗
 *
 * Three values happen to agree (PENDING, SHIPPED, CANCELLED); six do not. The
 * two its remaining importers touch are both in the agreeing set — which is why
 * this has never broken:
 *   src/components/posts/ProductCard.vue — `PENDING` default + `!== CANCELLED`
 *   src/pages/CartPage.vue              — the same two comparisons
 * The six disagreeing members are harmless solely because nothing reads them.
 * Anyone comparing a real backend status against, say, `OrderBoxItemStatus.ISSUE`
 * gets a silently false answer.
 *
 * Retirement is DEFERRED to a dedicated cleanup pass per the repo's
 * no-inline-deletes rule: repoint those four call sites at `ItemStatus`, then
 * delete this file.
 */
export const OrderBoxItemStatus = {
  PENDING: 1,
  COLLECTING: 2,
  COLLECTED: 3,
  PACKAGED: 4,
  SHIPPED: 5,
  DELIVERED: 6,
  CANCELLED: 7,
  OUT_OF_STOCK: 8,
  ISSUE: 9,
};
